import React, { useState, useEffect } from "react";
import { Menu, Segment } from "semantic-ui-react";
import { useSelector } from "react-redux"; 
import { useNavigate, useLocation } from "react-router-dom";
import SettingsNavbar from "../../components/SettingsNavbar";
import Sidebar from "../../components/Sidebar";
import PrivacyPolicy from "./PrivacyPolicy";
import Faq from "./Faq";
import "../../styles/Settings.css";

const Settings = ({ showSidebar }) => {
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated); 
  const [toggleBtn, setToggleBtn] = useState(window.innerWidth >= 1140);
  const navigate = useNavigate();
  const location = useLocation();
  const [activeItem, setActiveItem] = useState(location.pathname.includes("faq") ? "FAQ" : "Privacy Policy");

  const toggleSidebar = () => {
    if (isAuthenticated && window.innerWidth < 1140) {
      setToggleBtn(prevState => !prevState);
    }
  };

  const handleItemClick = (e, { name }) => {
    setActiveItem(name);
    if (name === "Privacy Policy") {
      navigate("/settings/privacy-policy");
    } else if (name === "FAQ") {
      navigate("/settings/faq");
    }
  };

  const handleCloseButtonClick = () => {
    setToggleBtn(false);
  };

  const handleResize = () => {
    if (window.innerWidth >= 1140 && isAuthenticated) {
      setToggleBtn(true);
    } else {
      setToggleBtn(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isAuthenticated]);

  useEffect(() => {
    if (location.pathname.includes("privacy-policy")) {
      setActiveItem("Privacy Policy");
    } else if (location.pathname.includes("faq")) {
      setActiveItem("FAQ");
    }
  }, [location.pathname]);

  return (
    <div className="settings-page">
      <SettingsNavbar setToggle={toggleSidebar} isAuthenticated={isAuthenticated} />
      {isAuthenticated && toggleBtn && (
        <Sidebar toggleBtn={toggleBtn} onCloseButtonClick={handleCloseButtonClick} />
      )}
      <div className={`settings-container ${isAuthenticated ? (toggleBtn ? '' : 'full-width') : 'not-authenticated'}`}>
        <Menu pointing secondary>
          <div className="MenuItem">
            <Menu.Item
              className="SettingsItem"
              name="Privacy Policy"
              active={activeItem === "Privacy Policy"}
              onClick={handleItemClick}
            />
            <Menu.Item
              className="SettingsItem"
              name="FAQ"
              active={activeItem === "FAQ"}
              onClick={handleItemClick}
            />
          </div>
        </Menu>
        <Segment>
          {activeItem === "Privacy Policy" && <PrivacyPolicy />}
          {activeItem === "FAQ" && <Faq />}
        </Segment>
      </div>
    </div>
  );
};

export default Settings;
